import React from 'react'

const IconMarkerSkip = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <circle cx='12' cy='12' r='9' />
         <line x1='5.5' y1='5.5' x2='18.5' y2='18.5' />
      </svg>
   )
}
export default IconMarkerSkip
